import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { ISalesInvoiceItemReportGetAllParams } from "@api/stores/salesInvoiceItemReport/types";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  ISalesInvoiceItemReportGetAllParams
>("stores.salesInvoiceItemReport.exportPDF");

export const exportPDF = {
  ...getApis,
};
